"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._ModuleMapping = exports._Messages = exports._DataSetValidation = void 0;
var object_service_1 = require("../../../object-service");
var translation_1 = __importDefault(require("../../../translation"));
var available_contracts_module_1 = require("../modules/available-contracts.module");
var cancel_contracts_module_1 = require("../modules/cancel-contracts.module");
var change_data_module_1 = require("../modules/change-data.module");
var customer_data_module_1 = require("../modules/customer-data.module");
var my_contracts_module_1 = require("../modules/my-contracts.module");
var referrals_module_1 = require("../modules/referrals.module");
var thank_you_module_1 = require("../modules/thank-you.module");
exports._DataSetValidation = {
    firstName: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidFirstname'),
    },
    lastName: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidLastname'),
    },
    dateOfBirth: {
        regex: /^\d{4}-\d{2}-\d{2}$/,
        regexError: translation_1.default.t('noValidBirthday'),
    },
    street: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidStreetName'),
    },
    houseNumber: {
        regex: /^.*$/,
        regexError: '',
    },
    zipCode: {
        regex: /^.*$/,
        regexError: '',
    },
    city: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidCity'),
    },
    bankAccount: {
        accountHolder: {
            regex: /^\D{2,}$/,
            regexError: translation_1.default.t('noValidName'),
        },
        bankName: {
            regex: /^\D{2,}$/,
            regexError: translation_1.default.t('noValidBankName'),
        },
        bic: {
            regex: /^([A-Z0-9]{8}|[A-Z0-9]{11})$/,
            regexError: translation_1.default.t('noValidBic'),
        },
        iban: {
            regex: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{0,30}$/,
            regexError: translation_1.default.t('noValidIBAN'),
        },
    },
    email: {
        regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
        regexError: translation_1.default.t('noValidEmail'),
    },
    phonePrivate: {
        regex: /^\d{5,}$/,
        regexError: translation_1.default.t('noValidPhoneNumber'),
    },
};
exports._Messages = {
    GetError: "An unexpected error occurred while retrieving your data. We're sorry for the inconvenience",
    PostError: "An unexpected error occurred while posting your amendments. We're sorry for the inconvenience",
    PostSuccess: 'Your amendments were successfully posted',
};
exports._ModuleMapping = {
    "change-data": object_service_1.ObjectService.getInstance(change_data_module_1.ChangeDataModule),
    "my-contracts": object_service_1.ObjectService.getInstance(my_contracts_module_1.MyContractsModule),
    "available-contracts": object_service_1.ObjectService.getInstance(available_contracts_module_1.AvailableContractsModule),
    "available-modules": object_service_1.ObjectService.getInstance(available_contracts_module_1.AvailableContractsModule),
    "customer-data": object_service_1.ObjectService.getInstance(customer_data_module_1.CustomerDataModule),
    "referrals": object_service_1.ObjectService.getInstance(referrals_module_1.ReferralsModule),
    "cancel-contract": object_service_1.ObjectService.getInstance(cancel_contracts_module_1.CancelContractsModule),
    "thank-you": object_service_1.ObjectService.getInstance(thank_you_module_1.ThankYouModule),
};
